module.exports = __webpack_public_path__ + "img/A3.c11bef97.png";